import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";
import { Minus, Plus, ArrowLeft } from "lucide-react";

export default function ProductDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);
    const [qty, setQty] = useState(1);
    const { add } = useCart();

    useEffect(() => {
        api.get(`/products/${id}`).then((r) => setProduct(r.data));
    }, [id]);

    if (!product) return <div className="px-6 py-20 font-serif text-2xl">Loading…</div>;

    const handleAdd = () => {
        add(product, qty);
        toast.success(`${product.name} added to cart`);
    };

    const handleBuyNow = () => {
        add(product, qty);
        navigate("/cart");
    };

    return (
        <div data-testid="product-detail" className="px-6 md:px-12 lg:px-20 py-12 md:py-20 max-w-6xl mx-auto">
            <Link to="/shop" className="inline-flex items-center gap-2 eyebrow text-black/60 hover:text-[#B8860B] mb-10">
                <ArrowLeft size={14} /> Back to Shop
            </Link>
            <div className="grid md:grid-cols-2 gap-12 md:gap-20">
                <div className="aspect-square bg-[#F4F4F4]">
                    {product.image_url ? (
                        <img src={product.image_url} alt={product.name} className="w-full h-full object-cover" />
                    ) : (
                        <div className="w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-[#FAFAFA] to-[#F0E6C8] text-[#B8860B]">
                            <div className="font-serif text-9xl italic">{product.name?.[0] || "·"}</div>
                            <div className="eyebrow text-xs mt-4">{product.category || "merch"}</div>
                        </div>
                    )}
                </div>
                <div>
                    <div className="eyebrow text-[#B8860B] mb-4">{product.category}</div>
                    <h1 className="font-serif text-4xl md:text-5xl tracking-tight mb-4">{product.name}</h1>
                    <div className="font-sans text-2xl mb-8 tabular-nums">${product.price.toFixed(2)}</div>
                    <p className="text-black/65 font-light leading-relaxed mb-10">{product.description}</p>

                    <div className="flex items-center gap-6 mb-10">
                        <div className="flex items-center border border-black/20">
                            <button data-testid="qty-decrease" onClick={() => setQty(Math.max(1, qty - 1))} className="p-3 hover:bg-black hover:text-white transition-colors">
                                <Minus size={16} />
                            </button>
                            <span data-testid="qty-value" className="px-6 tabular-nums">{qty}</span>
                            <button data-testid="qty-increase" onClick={() => setQty(qty + 1)} className="p-3 hover:bg-black hover:text-white transition-colors">
                                <Plus size={16} />
                            </button>
                        </div>
                        <span className="text-xs text-black/50 eyebrow">{product.stock} in stock</span>
                    </div>

                    <div className="flex flex-wrap gap-4">
                        <button data-testid="add-to-cart-detail" onClick={handleAdd} className="kind-btn-secondary">
                            Add to Cart
                        </button>
                        <button data-testid="buy-now" onClick={handleBuyNow} className="kind-btn-gold">
                            Buy Now
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
